import React from "react";
import Icons from "../../../../components/UI/Icons";
import FormInputs from "../../../../components/UI/FormInputs";

const FieldsDisplay = (props) => {
  const {
    fields,
    normalCheckedFormIds,
    handleNormalSubmit,
    setNormalCheckedFormIds,
    setSelectedFormIds,
    selectedFormIds,
    handleCheckboxChange,
    fieldSearched,
    handleSearch,
    SetFieldSearched,
    allSelected,
    searchTerm,
    setSearchTerm,
    setActiveSearchSource,
    setCurrentSearchLabel,
    activeSearchSource,
    selectedTab
  } = props;
  return (
    <div className="col-3">
      <div className="sh_emrcardrow">
        <div className="border-0 sh_emrfieldcardbox mb-1 sh_cardBox" style={{height:"calc(100vh - 490px)"}}>
          <div className="sh_emrcardHead sh_cardHeader py-2 px-2 position-relative">
            <div class="d-flex  align-items-center w-100">
              <div class="d-flex  justify-content-start w-100">
                {/* <span class="sh_emr_roundbadge normal">N</span> */}
                {selectedTab === "Order/Results" || selectedTab === "Assessment" ? (
                  <Icons type={"blue"} fontSize={"23px"} />
                ) : (
                  <span
                    className={`sh_emr_roundbadge ${
                      fields.length > 0
                        ? fields.every((f) =>
                            normalCheckedFormIds.includes(f.emr_form_id)
                          )
                          ? "normal"
                          : fields.some((f) =>
                              normalCheckedFormIds.includes(f.emr_form_id)
                            )
                          ? "inactive"
                          : ""
                        : ""
                    }`}
                    title="Normal"
                    onClick={async () => {
                      if (fields.length === 0) return;

                      const allSelected =
                        fields.length > 0 &&
                        fields.every((f) =>
                          normalCheckedFormIds.includes(f.emr_form_id)
                        );

                      const formIdsToProcess = fields
                        .filter((f) =>
                          allSelected
                            ? normalCheckedFormIds.includes(f.emr_form_id)
                            : !normalCheckedFormIds.includes(f.emr_form_id)
                        )
                        .map((f) => f.emr_form_id);

                      const combinedIds = formIdsToProcess.join(",");

                      await handleNormalSubmit(
                        combinedIds,
                        allSelected ? 0 : 1,
                        allSelected ? 1 : 0
                      );

                      if (allSelected) {
                        setNormalCheckedFormIds((prev) =>
                          prev.filter((id) =>
                            fields.every((f) => !formIdsToProcess.includes(id))
                          )
                        );
                      } else {
                        setNormalCheckedFormIds((prev) => [
                          ...new Set([...prev, ...formIdsToProcess]),
                        ]);

                        setSelectedFormIds((prev) =>
                          prev.filter(
                            (id) => !fields.some((f) => f.emr_form_id === id)
                          )
                        );
                      }
                    }}
                  >
                    N
                  </span>
                )}

                <span
                  className={`sh_emr_roundbadge ${
                    fields.length > 0
                      ? fields.every((f) =>
                          selectedFormIds.includes(f.emr_form_id)
                        )
                        ? "chart"
                        : fields.some((f) =>
                            selectedFormIds.includes(f.emr_form_id)
                          )
                        ? "inactive"
                        : ""
                      : ""
                  }`}
                  title="Chart"
                  onClick={async () => {
                    if (fields.length === 0) return;
                    const allSelectedNow =
                      fields.length > 0 &&
                      fields.every((f) =>
                        selectedFormIds.includes(f.emr_form_id)
                      );

                    const formIdsToProcess = fields
                      .filter(
                        (f) =>
                          allSelectedNow
                            ? selectedFormIds.includes(f.emr_form_id) // being removed
                            : !selectedFormIds.includes(f.emr_form_id) // being added
                      )
                      .map((f) => f.emr_form_id);

                    const combinedIds = formIdsToProcess.join(",");

                    // 🔁 Call API with correct flag
                    await handleNormalSubmit(
                      combinedIds,
                      0,
                      allSelectedNow ? 1 : 0
                    );

                    if (allSelectedNow) {
                      // Deselect all charts
                      setSelectedFormIds((prev) =>
                        prev.filter(
                          (id) => !fields.some((f) => f.emr_form_id === id)
                        )
                      );
                    } else {
                      // Select all charts
                      const newIds = fields.map((f) => f.emr_form_id);
                      setSelectedFormIds((prev) => [
                        ...new Set([...prev, ...newIds]),
                      ]);

                      // Uncheck all N
                      setNormalCheckedFormIds((prev) =>
                        prev.filter(
                          (id) => !fields.some((f) => f.emr_form_id === id)
                        )
                      );

                      fields.forEach(({ emr_form_id, name }) => {
                        if (!selectedFormIds.includes(emr_form_id)) {
                          handleCheckboxChange(emr_form_id, true);
                          if (fieldSearched) {
                            handleSearch(emr_form_id, name, false);
                            SetFieldSearched(false);
                          }
                        }
                      });
                    }
                  }}
                  role="checkbox"
                  aria-checked={allSelected}
                  tabIndex={0}
                >
                  C
                </span>
              </div>
              <h6 class="mb-0 text-sm  font-weight-bold sh_emrchartfieldheader">
                Charts
              </h6>
              <div class="d-flex align-items-center w-100 justify-content-center"></div>
            </div>

            <div className=" emrinlinesearchbox ">
              {/* <Buttons
             className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
             clickHandler={handleSearch}
             iconType={"SearchDarkBg"}
             /> */}
              <button
                type="button"
                className="emrinlinesearchicon btn btn-icon btn-transparent-dark"
                onClick={handleSearch}
              >
                <Icons type={"SearchDarkBg"} />
              </button>
              <FormInputs
                type="text"
                name="text"
                className="emrinlinesearchinput"
                placeholder="search.."
                value={searchTerm}
                changeHandler={(val) => {
                  setSearchTerm(val);
                  setActiveSearchSource("field");
                  setCurrentSearchLabel(val);
                }}
                readOnly={
                  activeSearchSource === "selectlist" ||
                  activeSearchSource === "history"
                }
              />
            </div>
          </div>

          <div className="sh_emrcardBody sh_cardBody">
            {fields.length === 0 ? (
              <div className="text-center text-muted py-3">
                No Charts Available , Please Configure in "EMR Fields setup"
              </div>
            ) : (
              fields.map(({ emr_form_id, name }, idx) => {
                const id = `field-check-${emr_form_id}`;
                const isChecked = selectedFormIds.includes(emr_form_id);

                return (
                  <div className="row" key={id}>
                    <div className="w-25 px-1">
                      <div className="d-flex justify-content-start w-100">
                        {/* <span className="sh_emr_roundbadge inactive">N</span> */}
                        {selectedTab === "Order/Results" || selectedTab === "Assessment" ? (
                          <span
                            style={{
                              paddingTop: "2px",
                              display: "inline-block",
                            }}
                          >
                            <Icons type={"blue"} fontSize={"23px"} />
                          </span>
                        ) : (
                          <span
                            className={`sh_emr_roundbadge ${
                              normalCheckedFormIds.includes(emr_form_id)
                                ? "normal"
                                : selectedFormIds.includes(emr_form_id)
                                ? "inactive"
                                : ""
                            }`}
                            title="Normal"
                            onClick={async () => {
                              const isChecked =
                                normalCheckedFormIds.includes(emr_form_id);
                              const newChecked = !isChecked;

                              // Update local state
                              setNormalCheckedFormIds((prev) =>
                                newChecked
                                  ? [...prev, emr_form_id]
                                  : prev.filter((id) => id !== emr_form_id)
                              );

                              // Uncheck C if new N is checked
                              if (newChecked) {
                                setSelectedFormIds((prev) =>
                                  prev.filter((id) => id !== emr_form_id)
                                );
                              }

                              // Call API with dynamic values
                              await handleNormalSubmit(
                                emr_form_id,
                                newChecked ? 1 : 0,
                                newChecked ? 0 : 1
                              );
                            }}
                            role="checkbox"
                            aria-checked={normalCheckedFormIds.includes(
                              emr_form_id
                            )}
                            tabIndex={0}
                            style={{ cursor: "pointer" }}
                          >
                            N
                          </span>
                        )}

                        <span
                          className={`sh_emr_roundbadge ${
                            selectedFormIds.includes(emr_form_id)
                              ? "chart"
                              : normalCheckedFormIds.includes(emr_form_id)
                              ? "inactive"
                              : ""
                          }`}
                          title="Chart"
                          onClick={async () => {
                            const newChecked = !isChecked;

                            await handleNormalSubmit(
                              emr_form_id,
                              0,
                              newChecked ? 0 : 1
                            );

                            handleCheckboxChange(emr_form_id, newChecked);

                            if (newChecked) {
                              setNormalCheckedFormIds((prev) =>
                                prev.filter((id) => id !== emr_form_id)
                              );
                            }

                            if (newChecked && fieldSearched) {
                              handleSearch(emr_form_id, name, false);
                              SetFieldSearched(false);
                            }
                            // fetchEmrList();
                          }}
                          role="checkbox"
                          aria-checked={isChecked}
                          tabIndex={0}
                          style={{ cursor: "pointer" }}
                        >
                          C
                        </span>
                      </div>
                    </div>

                    <div className="w-75  pl-3 d-flex align-items-center">
                      <label
                        className="formlabel text-wrap-anywhere mb-0"
                        htmlFor={id}
                      >
                        {name}
                      </label>
                    </div>
                    {/* <div className="col-1">
                    <CheckboxInput
                      label="Required"
                      className="form-check"
                      value={isChecked}
                      name="is_required"
                      id={id}
                      changeHandler={(val, { e }) => {
                        handleCheckboxChange(
                          emr_form_id,
                          e.target.checked
                        );
                        if (fieldSearched) {
                          handleSearch(
                            emr_form_id,
                            name,
                            false
                          );
                          SetFieldSearched(false);
                        }
                      }}
                    />
                  </div>
                  <div className="col-10 d-flex align-items-center">
                    <label
                      className="formlabel mb-0"
                      htmlFor={id}
                    >
                      {name}
                    </label>
                  </div> */}
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldsDisplay;
